import React from "react";
import { MapPin } from "lucide-react";
import { t } from "../../../utils/i18n";
import VenueField from "../../VenueField";

export interface DatePlace { name: string; address?: string; lat?: number; lng?: number; venue_id?: string }

// Distance à vol d'oiseau (km), jamais l'adresse exacte du domicile — seule la position de
// l'utilisateur (déjà connue côté profil) sert à calculer cette distance, jamais affichée elle-même.
function haversineKm(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export default function PlaceStep({
  lang, value, onChange, myLat, myLng,
}: {
  lang: string; value: DatePlace | null; onChange: (place: DatePlace | null) => void;
  myLat?: number | null; myLng?: number | null;
}) {
  const [text, setText] = React.useState(value?.name || "");

  const handleFieldChange = (name: string, venueId?: string | null, lat?: number | null, lng?: number | null) => {
    setText(name);
    if (!name) { onChange(null); return; }
    onChange({ name, venue_id: venueId || undefined, lat: lat ?? undefined, lng: lng ?? undefined });
  };

  const distanceKm = value?.lat != null && value?.lng != null && myLat != null && myLng != null
    ? haversineKm(myLat, myLng, value.lat, value.lng) : null;

  return (
    <div>
      <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 4 }}>{t(lang, "date_step_place_title")}</div>
      <div style={{ fontSize: 12.5, color: "#999", marginBottom: 16 }}>{t(lang, "date_step_place_sub")}</div>
      <VenueField value={text} onChange={handleFieldChange} lang={lang} onNavigate={() => {}} hideCreate />
      {value?.name && (
        <div style={{ display: "flex", alignItems: "flex-start", gap: 10, marginTop: 14, padding: 14, borderRadius: 14, backgroundColor: "#fafafa", border: "1px solid #eee" }}>
          <MapPin size={16} color="#0a0a0a" style={{ flexShrink: 0, marginTop: 2 }} />
          <div>
            <div style={{ fontSize: 14, fontWeight: 700 }}>{value.name}</div>
            {value.address && <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>{value.address}</div>}
            {distanceKm != null && <div style={{ fontSize: 11.5, color: "#999", marginTop: 2 }}>{distanceKm < 1 ? "< 1 km" : `${distanceKm.toFixed(1)} km`}</div>}
          </div>
        </div>
      )}
    </div>
  );
}
